import { EventBus } from '@/eventBus';

const INACTIVITY_TIMEOUT = 5 * 60 * 1000; // 5 minutes in milliseconds
const WARNING_TIMEOUT = 5 * 60 * 1000; // 4 minutes warning before timeout (1 minute before logout)

const state = {
  inactivityTimer: null,
  warningTimer: null,
  isWarningShown: false,
  isTracking: false,
};

const mutations = {
  SET_INACTIVITY_TIMER(state, timer) {
    state.inactivityTimer = timer;
  },
  SET_WARNING_TIMER(state, timer) {
    state.warningTimer = timer;
  },
  SET_WARNING_SHOWN(state, isShown) {
    state.isWarningShown = isShown;
  },
  SET_TRACKING(state, isTracking) {
    state.isTracking = isTracking;
  },
  REPLACE_STATE(state, newState) {
    Object.assign(state, newState);
  },
};

const actions = {
  startTracking({ dispatch, commit }) {
    commit('SET_TRACKING', true);
    dispatch('resetTimers');
    dispatch('setupEventListeners');
  },

  stopTracking({ dispatch, commit }) {
    commit('SET_TRACKING', false);
    dispatch('clearTimers');
    dispatch('removeEventListeners');
  },

  resetTimers({ dispatch, commit }) {
    dispatch('clearTimers');

    const inactivityTimer = setTimeout(() => {
      dispatch('handleInactivity');
    }, INACTIVITY_TIMEOUT);

    const warningTimer = setTimeout(() => {
      dispatch('showWarning');
    }, WARNING_TIMEOUT);

    commit('SET_INACTIVITY_TIMER', inactivityTimer);
    commit('SET_WARNING_TIMER', warningTimer);
  },

  clearTimers({ state, commit }) {
    if (state.inactivityTimer) {
      clearTimeout(state.inactivityTimer);
      commit('SET_INACTIVITY_TIMER', null);
    }
    if (state.warningTimer) {
      clearTimeout(state.warningTimer);
      commit('SET_WARNING_TIMER', null);
    }
  },

  setupEventListeners({ dispatch }) {
    const events = ['mousemove', 'keydown', 'click', 'scroll', 'touchstart'];
    const handleUserActivity = () => dispatch('handleUserActivity');

    events.forEach((event) => {
      window.addEventListener(event, handleUserActivity);
    });
  },

  removeEventListeners({ dispatch }) {
    const events = ['mousemove', 'keydown', 'click', 'scroll', 'touchstart'];
    const handleUserActivity = () => dispatch('handleUserActivity');

    events.forEach((event) => {
      window.removeEventListener(event, handleUserActivity);
    });
  },

  handleUserActivity({ state, dispatch }) {
    dispatch('resetTimers');
    EventBus.$emit('user-activity');
  },

  showWarning({ commit }) {
    commit('SET_WARNING_SHOWN', true);
    EventBus.$emit('inactivity-warning', {
      message: 'Your session will expire in 1 minute due to inactivity.',
      timeLeft: 1,
    });
  },

  hideWarning({ commit }) {
    commit('SET_WARNING_SHOWN', false);
    EventBus.$emit('inactivity-warning-dismissed');
  },

  handleInactivity({ dispatch }) {
    dispatch('showWarning');
    dispatch('clearTimers');
    dispatch('logout', null, { root: true });
    EventBus.$emit('session-expired');
  },
};

const getters = {
  isWarningShown: (state) => state.isWarningShown,
  isTracking: (state) => state.isTracking,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
